import React from 'react';
import Helmet from 'react-helmet';
import NotificationsContainer from '../containers/Notifications/NotificationsContainer';
import HeroTile from '../presentational/Dashboard/HeroTile/HeroTile';
import Search from '../presentational/Search/Search';
import DashboardContainer from '../containers/Dashboard/DashboardContainer';

const pageHeaderRef = React.createRef<HTMLHeadingElement>();
const updateFocusOnNotificationClose = () => {
	//@ts-ignore
	pageHeaderRef.current.focus();
};

const AdviserHome: React.FunctionComponent = () => {
	return (
		<React.Fragment>
			<Helmet>
				<title>Dashboard</title>
			</Helmet>
			<NotificationsContainer
				updateFocusOnNotificationClose={updateFocusOnNotificationClose}
			/>
			<HeroTile forwardedRef={pageHeaderRef}>
				<Search isAdvanced={false} />
			</HeroTile>
			<DashboardContainer />
		</React.Fragment>
	);
};

export default AdviserHome;
